import { Outlet } from 'react-router-dom'
import Navbar from '@components/Navbar/Navbar.jsx'
import Footer from '@components/Footer/Footer.jsx'

export default function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-black">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
